"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _formsyReact = require("formsy-react");

var _componentCommon = require("../components/component-common");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getDisplayName = function getDisplayName(component) {
  return component.displayName || component.name || (typeof component === 'string' ? component : 'Component');
}; // Component HOC
// -------------
//
// This HOC provides shared code for our form components.
//
// We use this to merge props set using our OptionsProvider, so that
// we can set commonly used props on an enclosing component.
//
// This allows us to set these properties 'as a whole' for each component in the
// the form, while retaining the ability to override the prop on a per-component
// basis.


var FormsyReactComponent = function FormsyReactComponent(ComposedComponent) {
  var ComponentHOC =
  /*#__PURE__*/
  function (_Component) {
    _inherits(ComponentHOC, _Component);

    function ComponentHOC() {
      var _getPrototypeOf2;

      var _this;

      _classCallCheck(this, ComponentHOC);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ComponentHOC)).call.apply(_getPrototypeOf2, [this].concat(args)));

      _defineProperty(_assertThisInitialized(_this), "getLayout", function () {
        var layout = _this.props.layout;
        var layoutContext = _this.context.layout;
        return layout || layoutContext || 'horizontal';
      });

      _defineProperty(_assertThisInitialized(_this), "getValidatePristine", function () {
        var validatePristine = _this.props.validatePristine;

        if (typeof validatePristine === 'boolean') {
          return validatePristine;
        }

        var validatePristineContext = _this.context.validatePristine;
        return validatePristineContext || false;
      });

      _defineProperty(_assertThisInitialized(_this), "getValidateOnSubmit", function () {
        var validateOnSubmit = _this.props.validateOnSubmit;

        if (typeof validateOnSubmit === 'boolean') {
          return validateOnSubmit;
        }

        var validateOnSubmitContext = _this.context.validateOnSubmit;
        return validateOnSubmitContext || false;
      });

      _defineProperty(_assertThisInitialized(_this), "getId", function () {
        var _this$props = _this.props,
            id = _this$props.id,
            label = _this$props.label,
            name = _this$props.name;

        if (id !== '') {
          return id;
        }

        return ['frc', name.split('[').join('_').replace(']', ''), _this.hashString(JSON.stringify(label))].join('-');
      });

      _defineProperty(_assertThisInitialized(_this), "combineContextWithProp", function (key) {
        var contextValue = _this.context[key];
        var propsValue = _this.props[key];
        return [contextValue, propsValue];
      });

      _defineProperty(_assertThisInitialized(_this), "hashString", function (string) {
        var hash = 0;

        for (var i = 0; i < string.length; i += 1) {
          // eslint-disable-next-line no-bitwise
          hash = (hash << 5) - hash + string.charCodeAt(i) & 0xffffffff;
        }

        return hash;
      });

      _defineProperty(_assertThisInitialized(_this), "shouldShowErrors", function () {
        var _this$props2 = _this.props,
            isPristine = _this$props2.isPristine,
            isFormSubmitted = _this$props2.isFormSubmitted,
            isValid = _this$props2.isValid;

        if (isPristine() === true) {
          if (_this.getValidatePristine() === false) {
            return false;
          }
        }

        if (_this.getValidateOnSubmit() === true) {
          if (isFormSubmitted() === false) {
            return false;
          }
        }

        return isValid() === false;
      });

      return _this;
    }

    _createClass(ComponentHOC, [{
      key: "render",
      // We pass through all unknown props, but delete some formsy HOC props
      // that we know we don't need.
      value: function render() {
        var _this$props3 = this.props,
            componentRef = _this$props3.componentRef,
            disabled = _this$props3.disabled,
            getErrorMessages = _this$props3.getErrorMessages,
            getValue = _this$props3.getValue,
            isFormDisabled = _this$props3.isFormDisabled,
            isPristine = _this$props3.isPristine,
            isRequired = _this$props3.isRequired,
            setValue = _this$props3.setValue;

        var props = _objectSpread({}, this.props, {
          elementWrapperClassName: this.combineContextWithProp('elementWrapperClassName'),
          labelClassName: this.combineContextWithProp('labelClassName'),
          rowClassName: this.combineContextWithProp('rowClassName'),
          disabled: isFormDisabled() || disabled,
          errorMessages: getErrorMessages(),
          id: this.getId(),
          isPristine: isPristine,
          layout: this.getLayout(),
          ref: componentRef,
          required: isRequired(),
          showErrors: this.shouldShowErrors(),
          value: getValue(),
          onSetValue: setValue
        }); // Props that we don't need to pass to our composed components.


        var unusedPropNames = [// From formsy-react HOC...
        'getErrorMessage', 'getErrorMessages', 'getValue', 'hasValue', 'isFormDisabled', 'isFormSubmitted', 'isRequired', 'isValid', 'isValidValue', 'resetValue', 'setValidations', 'setValue', 'showError', 'showRequired', 'validationError', 'validationErrors', 'validations', 'innerRef', // From formsy-react-component HOC...
        'componentRef', 'validateOnSubmit', 'validatePristine'];
        unusedPropNames.forEach(function (propName) {
          delete props[propName];
        });
        return _react.default.createElement(ComposedComponent, props);
      }
    }]);

    return ComponentHOC;
  }(_react.Component);

  ComponentHOC.propTypes = _objectSpread({
    // These are the props that we require from the formsy-react HOC.
    getErrorMessages: _propTypes.default.func.isRequired,
    getValue: _propTypes.default.func.isRequired,
    isFormDisabled: _propTypes.default.func.isRequired,
    isPristine: _propTypes.default.func.isRequired,
    isRequired: _propTypes.default.func.isRequired,
    isValid: _propTypes.default.func.isRequired,
    setValue: _propTypes.default.func.isRequired
  }, _componentCommon.styleClassNames, {
    name: _propTypes.default.string.isRequired,
    disabled: _propTypes.default.bool,
    // Composed components expect this to be a string.
    help: _propTypes.default.string,
    id: _propTypes.default.string,
    label: _propTypes.default.node,
    layout: _propTypes.default.string,
    // * validateOnSubmit
    // * validatePristine
    //
    // Neither of these props actually stop the validations from running,
    // they just determine whether the error messages should be shown on
    // components or not.
    // Whether to hide validation errors on components before the form is
    // submitted.
    validateOnSubmit: _propTypes.default.bool,
    // Whether to show validation errors on pristine (untouched) components.
    validatePristine: _propTypes.default.bool
  });
  ComponentHOC.contextTypes = _objectSpread({}, _componentCommon.styleClassNames, {
    layout: _propTypes.default.string,
    validateOnSubmit: _propTypes.default.bool,
    validatePristine: _propTypes.default.bool
  }); // TODO: Should we add default props for the following?:
  // * elementWrapperClassName
  // * labelClassName
  // * rowClassName
  // The following props get their default values by first looking for props in the parent context.
  // * layout (See getLayout, defaults to 'horizontal')
  // * validatePristine: (See getValidatePristine, defaults to 'false'),
  // * validateOnSubmit: (See getValidateOnSubmit, defaults to 'false'),

  ComponentHOC.defaultProps = {
    disabled: false,
    help: '',
    id: '',
    label: '',
    layout: '',
    validateOnSubmit: null,
    validatePristine: null
  };
  ComponentHOC.displayName = "withFRC(".concat(getDisplayName(ComposedComponent), ")");
  return (0, _formsyReact.withFormsy)(ComponentHOC);
};

var _default = FormsyReactComponent;
exports.default = _default;